import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-video-block',
  templateUrl: './video-block.component.html',
  styleUrls: ['./video-block.component.scss']
})
export class VideoBlockComponent implements OnInit {

  @Input() classes: string;

  constructor() { }

  ngOnInit() {
  }

}
